import type {MergeTag} from '@Components/merge-tags/merge-tags.types';
import {capitalizeFirstLetter} from '@Utils/string.util';

export function getPMWMergeTagRegex(): RegExp {
  return /\[\[(.*?)(?:::(.*?))?\]\]/g;
}

export function replaceMergeTag(value: MergeTag['mergeTagKey'], currentContent: string, replaceWith: string): string {
  const escapedValue = capitalizeFirstLetter(value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const regex = new RegExp(`\\[\\[${escapedValue}(::[^\\]]*)?\\]\\]`, 'g');
  return currentContent.replace(regex, replaceWith);
}
